<template>
  <d2-container class="test">
    <!-- 表格头部搜索 -->
    <template slot="header">
      <div style="width: 73%; display: flex; float: left; height: 48px">
        <span align="right" style="
              align: right;
              display: inline-block;
              width: 100px;
              line-height: 48px;
            ">关键字</span>
        <div style="padding: 8px 0px; width: 80%">
          <el-input clearable @keyup.enter.native="search()" style="margin-left: 10px; height: 48px" class="filter-item"
            placeholder="案号，当事人，批次号，状态" v-model="CaseInfo.keyWord" size="small">
          </el-input>
        </div>

      </div>
      <div style="display: flex; justify-content: center;
    align-items: center;margin-top:10px">
        <div style="text-align: center">
          <el-button style="width: 5rem" class="filter-item" type="primary" round icon="search" @click.stop="search()"
            size="small">搜索</el-button>
          <el-button style="width: 5rem" class="filter-item" type="danger" round icon="search" @click.stop="resetTemp()"
            size="small">重置</el-button>

        </div>
      </div>
      <div style="display: flex"></div>
    </template>


    <!-- 批量备注 -->
    <el-dialog title="批量备注" :visible.sync="showNotes" width="30%" center :close-on-click-modal="false">
      <el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="remark">
      </el-input>
      <div style="display: flex" class="notesBtn">
        <div>
          <el-button style="" type="primary" @click="batchRemark">确定</el-button>
        </div>
        <div>
          <el-button style="margin-left: 10px" type="" @click="showNotes = false">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <div style="display:flex">

      <el-upload ref="upload" :on-change="singFileChange" :action="getTableUrl()" :http-request="singleUploadFile"
        multiple :file-list="fileList" :limit="100">
        <el-button v-permission:function="['newCaseInfoManager_import']" type="primary" size="small"
          style="margin-left: 50px;height:30px;">
          导入案件 <i class=""></i>
        </el-button>
      </el-upload>
      <el-dropdown size="small" type="primary" @command="handleCommand" style="margin-left: 50px;">
        <el-button type="primary" size="small" v-permission:function="['czCaseInfoManager_batch_btn']">
          批量操作 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batchSetStatus"
            v-permission:function="['czCaseInfoManager_batch_setStatus']">批量修改案件状态</el-dropdown-item>
          <el-dropdown-item command="batchRemark">批量备注</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" size="small" style="margin-left: 50px;height:30px;" @click="getList('thisMouth')">本月统计<i
          class=""></i></el-button>
      <el-button type="primary" size="small" style="margin-left: 50px;height:30px;" @click="getList('preMouth')">上月统计<i
          class=""></i></el-button>

      <span style="margin-left: 20px;line-height:30px"> 自定义列表高度： </span>
      <el-input style="width: 10%;line-height:30px" type="number" v-model="tableHeight" @input="setTableHeight"
        placeholder="数字"></el-input>


    </div>


    <!-- 案件列表 -->
    <el-table v-loading.body="listLoading" border type="index" :data="list" size="small" :height="tableHeight" row-key
      :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
      style="width: 100vw; margin-top: 4px; overflow: auto">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column width="80" align="center" label="系统编号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="批次号">
        <template slot-scope="scope">
          <span>{{ scope.row.batchId }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" label="案由/法院名称/案号">
        <template slot-scope="scope">
          <div><el-link type="primary" :underline="false">{{ scope.row.cause }}</el-link></div>
          <div>{{ scope.row.courtName }}</div>
          <div>{{ scope.row.registerCode }}</div>
        </template>
      </el-table-column>

      <el-table-column width="250" align="center" label="当事人">
        <template slot-scope="scope">
          <div>{{ scope.row.plaintiffName }}</div>
          <el-link type="primary" @click="showEditPage(scope.$index, scope.row)">{{ scope.row.defendantName }}</el-link>
          <div v-for="czCard in scope.row.cardInfoList">{{ czCard.cardNumber }}</div>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.caseStatus == '异常'" type="info">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '处置中' || scope.row.caseStatus == '未处置'" type="warning">{{
            scope.row.caseStatus }}</el-tag>
          <el-tag v-else-if="scope.row.caseStatus == '新收案件'" type="danger">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else type="success">{{ scope.row.caseStatus }}</el-tag>
          <div v-if="scope.row.caseStatus == '已撤诉'">{{ scope.row.dropLawsuitReason }}</div>
          <div v-if="scope.row.caseStatus == '已退案'">{{ scope.row.withdrawalReason }}</div>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="委托日期">
        <template slot-scope="scope">
          <span>{{ scope.row.entrustmentDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="更新日期">
        <template slot-scope="scope">
          <span>{{ scope.row.editTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="110">
        <template slot-scope="scope">
          <el-button v-permission:function="['newCaseInfoManager_delete']" type="danger" @click="delete1(scope.row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>



    <!-- 批量修改案件状态 -->
    <el-dialog title="批量修改状态" :visible.sync="setStatusdialogVisible" width="50%" class="outDialog"
      :close-on-click-modal="false">
      <el-form ref="plCaseForm" :model="plStatus" label-width="170px">
        <el-form-item label="案件状态：" prop="caseSt" id="caseSt">
          <el-select style="width: 70%" v-model="plStatus.caseSt" placeholder="请选择">
            <el-option v-for="item in plCaseStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="委托日期：" prop="entrustmentDate" id="entrustmentDate">
          <el-date-picker style="width: 70%" v-model="plStatus.entrustmentDate" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" type="date" placeholder="选择委托日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" style="width: 160px; margin: 0 auto">
        <el-button @click="setStatusdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setCaseStatus()">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 分页 -->
    <template slot="footer">
      有效案件{{ this.newCaseCount + this.chuZhiCount + this.liAnTiaoJie }}件,其中
      <el-tag type="danger">新收阶段{{ this.newCaseCount }}件</el-tag>
      <el-tag type="warning">处置阶段{{ this.chuZhiCount }}件</el-tag>
      <el-tag type="success">立案调解阶段{{ this.liAnTiaoJie }}件</el-tag>
      ；无效案件{{ this.yiChang }}件,其中
      <el-tag type="info">异常阶段{{ this.yiChang }}件</el-tag>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="CaseInfo.page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]"
        :page-size="CaseInfo.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>

    <!-- 预览案件 -->
    <el-dialog class="previewDialog" custom-class="heightFull" :title="'预览案件'" :visible.sync="isPreview" width="70%"
      center :close-on-click-modal="false">
      <Preview :caseId="this.id" v-if="isPreview"></Preview>
    </el-dialog>
  </d2-container>
</template>
<style scoped>
@import "../../../assets/style/CaseInfo/caseInfo.css";
</style>
<script>
import {
  getList,
  uploadTable,
  batchSetStatus,
  batchRemark
} from "@/api/czManager/newCaseInfo/index";
import Preview from "@/pages/caseMediate/preview";
import util from "@/libs/util";
import {
  deletetCase,
  setCaseStatus,
} from "@/api/czManager/czCaseInfo/index";
import { getLastStartDayOfMonth, getLastEndDayOfMonth, getStartDayOfMonth, getEndDayOfMonth, getNowDay } from '@/utils/dateUtils'

export default {
  name: "userManager",
  components: {
    Preview,
  },
  data() {
    return {
      showNotes: false,
      plCaseStatus: [{
        labal: '处置中',
        value: '处置中'
      }, {
        labal: '新收案件',
        value: '新收案件'
      }, {
        labal: '异常',
        value: '异常'
      }],
      plStatus: { caseSt: "处置中" },
      remark: "",
      tableHeight: '510',
      total: 0,
      fileData: new FormData(),
      fileList: [],
      plaintiffName: [],
      setStatusdialogVisible: false,
      total: 0,
      isPreview: false,
      list: [],
      CaseInfo: {
        keyWord: '',
        page: 1,
        limit: 50,
      },
      listLoading: true,
      caseIdList: [],
      newCaseCount: '',
      chuZhiCount: '',
      liAnTiaoJie: '',
      yiChang: ''
    };
  },
  watch: {

  },
  created() {
    let h = localStorage.getItem("newCaseTableHeight");
    if (h != undefined && h != "" && h != null) {
      this.tableHeight = h;
    }
    this.getList();


  },
  computed: {
  },
  methods: {
    showEditPage(index, row) {
      console.log(row);
      this.id = row.id;
      this.isPreview = true;
      return;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.caseStatus == '新收案件') {
        return 'danger-row';
      } else if (row.caseStatus == '异常') {
        return 'none-row';
      } else if (row.caseStatus == '处置中' || row.caseStatus == '未处置') {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    handleCommand(command) {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选至少一个案件"); return;
      }
      if (command == 'batchSetStatus') {
        this.setStatusdialogVisible = true
      } else if (command == 'batchRemark') {
        this.showNotes = true
      }
    },
    singleUploadFile(val) {
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const token = util.cookies.get("token");
      this.fileData.append("file", val.file);
      uploadTable(this.fileData, token).then(res => {
        loading.close()
        if (res.data.statusCode === 2000) {
          this.$message.success(res.data.message)
          this.getList()
          this.fileData = new FormData()
          this.fileList = []
        } else {
          this.$message.error('失败')
          this.fileData = new FormData()
          this.fileList = []
        }
      }).catch(err => {
        loading.close()
        this.$message.error('新收案件文件格式有问题或文件类型不符合')
        this.fileData = new FormData()
        this.fileList = []
      })
      // uploadFile(this,{},{url:'/api/case/czCaseInfo/importCaseExcel'},(res=>{
      // }),this.$refs.upload )
    },
    singFileChange(file, fileList) {
      this.fileList = fileList
    },
    getTableUrl() {
      return (
        process.env.VUE_APP_API + "/czCaseInfo/importCaseExcel"
      );
    },
    batchRemark() {
      if (this.caseIdList.length < 1) { this.$message.error("请勾选至少一个案件"); return; }
      batchRemark({ caseIdList: this.caseIdList, remark: this.remark })
        .then(res => {
          if (res.statusCode == 2000) {
            this.$message.success("成功");
            this.getList()
            this.remark = ''
            this.showNotes = false
          }
        })
    },
    delete1(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        deletetCase(id).then((res) => {
          this.$notify({
            title: res.statusCode == 2000 ? "成功" : "失败",
            type: res.statusCode == 2000 ? "success" : "error",
            message: res.message,
            duration: 2000,
          });
          this.getList();
        });
      });

    },
    setTableHeight(val) {
      localStorage.setItem("newCaseTableHeight", val);
      this.tableHeight = val;
    },

    getList(param) {
      this.listLoading = true;
      if (param == 'thisMouth') {
        this.CaseInfo.entrustmentDateS = getStartDayOfMonth()
        this.CaseInfo.entrustmentDateE = getEndDayOfMonth()
      }
      else if (param == 'preMouth') {
        this.CaseInfo.entrustmentDateS = getLastStartDayOfMonth()
        this.CaseInfo.entrustmentDateE = getLastEndDayOfMonth()
      }
      else if (param == 'nextPage') {

      }
      else {
        this.CaseInfo.entrustmentDateS = getLastStartDayOfMonth()
        this.CaseInfo.entrustmentDateE = getEndDayOfMonth()
      }

      getList(this.CaseInfo).then(res => {
        this.list = res.czCaseInfoPage.records
        this.total = res.czCaseInfoPage.total
        this.newCaseCount = res.newCaseCount
        this.chuZhiCount = res.chuZhiCount
        this.liAnTiaoJie = res.liAnTiaoJie
        this.yiChang = res.yiChang
        this.listLoading = false

      })
    },
    search() {
      this.CaseInfo.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.CaseInfo.limit = val;
      this.getList('nextPage');
    },
    handleCurrentChange(val) {
      this.CaseInfo.page = val;
      this.getList('nextPage');
    },
    /**
     * 多选框选择方法
     * @param {} val
     */
    handleSelectionChange(val) {
      let arr = [];
      for (let item of val) {
        arr.push(item.id);
      }
      this.caseIdList = arr;
    },

    setCaseStatus() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      this.$refs.plCaseForm.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("caseIdList", this.caseIdList);
          formData.append("status", this.plStatus.caseSt);
          formData.append(
            "date",
            this.plStatus.entrustmentDate == undefined ? '' : this.plStatus.entrustmentDate
          );
          batchSetStatus(formData).then(res => {
            if (res.statusCode == 2000) {
              this.setStatusdialogVisible = false
              this.$message.success('成功')
              this.getList()
            } else {
              this.$notify({
                title: "失败",
                message: res.message,
                type: "error",
                duration: 2000,
              });
            }
          })
        }
      });
    },
    resetTemp() {
      this.CaseInfo.keyWord = ''
      this.getList();
    },
  },
};
</script>
<style>
.el-table .danger-row {
  background: rgb(246, 201, 199);
}

.el-table .none-row {
  background: rgb(205, 204, 204);
}

.el-table .warning-row {
  background: #f0d8a7;
}

.el-table .success-row {
  background: #d7fcc4;
}
</style>